export default "__VITE_ASSET__278e4d96__"